import { getIssueStatusTool } from './get_issue_status.js';
import { listIssueStatusesTool } from './list_issue_statuses.js';

export const issueStatusTools = [listIssueStatusesTool, getIssueStatusTool];
